var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Tooltip',{staticClass:"icon",attrs:{"tooltip":_vm.$t(_vm.value ? 'In Sia': 'Not in Sia')}},[(_vm.value)?_c('i',{staticClass:"status-is-available fas fa-link"}):_c('i',{staticClass:"status-not-available fas fa-unlink"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }